import styled from 'styled-components';

export const Page = styled.main`
  box-sizing: border-box;
  min-height: 100vh;
  padding: 48px 20px;
  background: ${({ theme }) => theme.colors.gray000};
  color: ${({ theme }) => theme.colors.gray500};
`;

export const WorkflowContent = styled.div`
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
`;

export const Toolbar = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
`;

export const Header = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;

  h1,
  h2 {
    margin: 0 0 8px;
    font-size: ${({ theme }) => theme.fontSizes.md};
    overflow-wrap: anywhere;
  }

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.gray400};
  }

  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

export const Badge = styled.span`
  display: inline-block;
  padding: 6px 10px;
  border: 1px solid ${({ theme }) => theme.colors.primary100};
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.primary500};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: 600;
  white-space: nowrap;
`;

export const Notice = styled.div<{ danger?: boolean }>`
  margin: 16px 0;
  padding: 12px 14px;
  border: 1px solid ${({ danger, theme }) => (danger ? theme.colors.red : theme.colors.gray200)};
  border-radius: ${({ theme }) => theme.radii.base};
  background: ${({ danger, theme }) => (danger ? '#fff5f5' : theme.colors.gray000)};
  color: ${({ danger, theme }) => (danger ? '#8b1a1a' : theme.colors.gray500)};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin: 16px 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.section`
  box-sizing: border-box;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: ${({ theme }) => theme.radii.lg};
  background: ${({ theme }) => theme.colors.light};

  h2 {
    margin: 0 0 12px;
    font-size: ${({ theme }) => theme.fontSizes.md};
  }

  h3 {
    margin: 20px 0 10px;
    font-size: ${({ theme }) => theme.fontSizes.base};
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

export const SignerRow = styled.div`
  display: grid;
  align-items: end;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr) auto;
  gap: 8px;
  margin-bottom: 10px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.label`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
  color: ${({ theme }) => theme.colors.gray400};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

export const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  min-height: 42px;
  padding: 8px 10px;
  border: 1px solid ${({ theme }) => theme.colors.gray300};
  border-radius: ${({ theme }) => theme.radii.base};
  background: ${({ disabled, readOnly, theme }) => (disabled || readOnly ? theme.colors.gray000 : theme.colors.light)};
  color: ${({ theme }) => theme.colors.gray500};
  font-size: ${({ theme }) => theme.fontSizes.base};

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary300};
    outline-offset: 1px;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 16px;
`;

export const ProgressList = styled.ol`
  margin: 0;
  padding-left: 24px;

  li {
    padding: 5px 0;
    overflow-wrap: anywhere;
  }
`;

export const PublicContent = styled.div`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
`;
